// The production build names its bundle by content hash (main.<hash>.js) in index.html; the
// development server serves an unhashed bundle.js, so nothing here matches there.
const BUNDLE_PATTERN = /\/static\/js\/(main\.[0-9a-f]+\.js)/;

export const bundleIn = (html: string): string | null => html.match(BUNDLE_PATTERN)?.[1] ?? null;

/** The bundle this page was loaded with. */
export const runningBundle = (): string | null => {
    const script = document.querySelector<HTMLScriptElement>('script[src*="/static/js/main."]');
    return script ? bundleIn(script.getAttribute('src') || '') : null;
};

/** The bundle the server hands out now: index.html is never cached, so this is the current deploy. */
export const servedBundle = async (): Promise<string | null> => {
    const response = await fetch(`${process.env.PUBLIC_URL || ''}/index.html`, {cache: 'no-store'});
    return response.ok ? bundleIn(await response.text()) : null;
};
